import {Injectable} from '@angular/core';
import {EventRestService} from '../../../../api/services/event.rest.service';
import {EventViewModel} from './event.view-model';
import {EventApiModel} from '../../../../api/models/event.api.model';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserRestService} from '../../../../api/services/user.rest.service';
import {MediaObjectRestService} from '../../../../api/services/media-object.rest.service';
import {UsersQueryDataProviderService} from "../../../services/users-query.data-provider.service";
import {UserApiModel} from '../../../../api/models/user.api-model';

@Injectable({
  providedIn: 'root'
})
export class AddEventProviderService extends UsersQueryDataProviderService {

  constructor(
    private readonly eventRS: EventRestService,
    readonly userRS: UserRestService,
    readonly mediaObjectRS: MediaObjectRestService
  ) {
    super(userRS, mediaObjectRS);
  }

  public createEvent(eventVM: EventViewModel): Observable<EventApiModel> {
    const eventAM = EventApiModel.fromEventVM(eventVM);
    return this.eventRS.create(eventAM);
  }

  public updateEvent(eventVM: EventViewModel): Observable<EventApiModel> {
    const eventAM = EventApiModel.fromEventVM(eventVM);
    return this.eventRS.put(eventAM);
  }

  public findInvitationCandidate(email: string): Observable<UserApiModel[]> {
    if (!email.includes('@')) {
      return of([]);
    }
    return this.userRS.findInvitationCandidate(email).pipe(map(candidate => candidate ? [candidate] : []));
  }
}
